import LayoutMaster from "components/layout/layout_master";
import { alertWithDeposit } from "components/modal/deposit_modal";
import { alertWithDepositV2 } from "components/modal/deposit_modal_v2";
import { alertWithWithDraw } from "components/modal/withdraw_modal";
import { alertWithWithdrawV2 } from "components/modal/withdraw_modal_v2_helper";
import BankAccountShow from "components/view/bank_account_show";
import { CenterProps } from "lib/all_type/center_props";
import { IsCheckMutiBank } from "lib/helper/is_check_muti_bank";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import { GetInfoResponse } from "lib/worker/api/getinfo";
import { GetServerSideProps } from "next";
import { useRouter } from "next/router";
import Img from "react-cloudimage-responsive";
import { connect } from "react-redux";

interface BankPageProps extends CenterProps {
  getinfo: GetInfoResponse;
  isLogin: boolean;
  infomation: CheckWithPrefixResponse;
}

function BankPage(props: BankPageProps) {
  const getinfo = props.getinfo;
  const { isLogin } = props;
  const router = useRouter();

  const goToAddBank = () => {
    if (!isLogin) {
      props.alertWithMessage("กรุณาเข้าสู่ระบ");
      return;
    }
    router.push("/add_bank");
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "ฝาก - ถอน รวดเร็ว เพียง ไม่กี่นาที",
        description:
          "สามารถ ฝากเงิน ถอนเงิน ง่ายๆ รวดเร็ว ทันใจ เพียงไม่กี่นาที เว็บ พนันที่มีประสิทธิภาพมากที่สุด มีทั้ง บาคาร่า แทงบอล แทงบาส PG JOKER SA GAMING AE SEXY",
      }}
      information={props.infomation}
    >
      <>
        <div className="container">
          <div style={{ paddingTop: 0 }}>
            <div className="row" style={{ marginTop: 10 }}>
              <div className="col-6">
                <div
                  className="btn btn-purple-submit margin-top-10"
                  onClick={() => {
                    props.infomation.isPaymentV2
                      ? alertWithDepositV2()
                      : alertWithDeposit();
                  }}
                >
                  <div
                    className=""
                    style={{
                      width: 50,
                      height: 50,
                      float: "left",
                    }}
                  >
                    <Img
                      ratio={1}
                      src="icon-modal-deposit3.png"
                      alt="ฝาก"
                    ></Img>
                  </div>
                  <label
                    style={{ float: "left", marginTop: 13, marginLeft: 10 }}
                  >
                    ฝากเงิน
                  </label>
                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
              <div className="col-6">
                <div
                  className="btn background-blue-linear margin-top-10"
                  onClick={() => {
                    props.infomation.isPaymentV2
                      ? alertWithWithdrawV2()
                      : alertWithWithDraw();
                  }}
                >
                  <div
                    className=""
                    style={{
                      width: 50,
                      height: 50,
                      float: "left",
                    }}
                  >
                    <Img
                      ratio={1}
                      src="icon-modal-withdraw3.png"
                      alt="ฝาก"
                    ></Img>
                  </div>
                  <label
                    style={{ float: "left", marginTop: 13, marginLeft: 10 }}
                  >
                    ถอนเงิน
                  </label>
                  <div style={{ clear: "both" }}></div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {getinfo.Banks?.map((value, i) => {
              return (
                <div key={i} className="col-12">
                  <BankAccountShow
                    bankAccount={value?.Type}
                    bankImage={value?.Image}
                    bankName={value?.BankName}
                    bankColor={value?.Color}
                    bankNumber={value?.BankNumber}
                  ></BankAccountShow>
                </div>
              );
            })}
            {IsCheckMutiBank(getinfo) && (
              <div className="col-12">
                <div
                  className="card-add-bank color-font-card margin-top-15 text-center"
                  style={{ paddingTop: 63, paddingBottom: 63 }}
                  onClick={goToAddBank}
                >
                  <span>+ เพิ่มบัญชีธนาคาร</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
      <div className="container">
        <div className="col-12 grid margin-top-20">
          <div className="border-radius fade-color shadow">
            <div className="card color-font-card">
              <div className="heading margin-left-10 margin-right-10">
                <h2 className="font-bold">
                  <span>วิธีเพิ่มธนาคาร</span>
                </h2>
                <p className="bottom-line-yellow"></p>
              </div>
              <div className="card-body">
                <li>
                  กรอกข้อมูลให้ครบถ้วน จากนั้นขอรับรหัส <span>OTP</span>{" "}
                  ระบบจะส่งรหัสไปยังโทรศัพท์
                </li>
                <li>
                  กรอกรหัส <span>OTP</span> ที่ท่านได้รับ จากนั้นกดยืนยัน{" "}
                </li>
                <li className="font-red font-bold">
                  หากพบปัญหาในการเพิ่มบัญชีธนาคาร
                  กรุณาติดต่อเจ้าหน้าที่เพื่อรับทราบปัญหา
                </li>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 grid margin-top-10">
          <div className="border-radius shadow">
            <div className="card color-font-card">
              <div className="heading margin-left-10 margin-right-10">
                <h4 className="font-bold">
                  <span>วิธีฝากเงิน</span>
                </h4>
                <p className="bottom-line-yellow"></p>
              </div>
              <div className="card-body">
                <li>
                  เลือกปุ่ม <span>ฝากเงิน</span>
                </li>
                <li>
                  ระบุจำนวนเงินที่ต้องการฝาก จากนั้นกดปุ่ม <span>ยืนยัน</span>
                </li>
                <li>
                  หลังจากที่ท่านยืนยันรายการฝากเงิน
                  ระบบจะแสดงยอดเงินและตามด้วยเลขทศนิยม{" "}
                  <span>
                    *โปรดโอนเงินของท่านให้ถูกต้องตามที่ระบบแสดง รวมถึงจุดทศนิยม
                  </span>
                </li>
                <li>
                  โปรดตรวจสอบเลขที่บัญชีธนาคารปลายทางทุกครั้งก่อนทำการโอนเงิน
                </li>
                <li>
                  หลังจากที่ระบบได้ทำการเพิ่มเครดิตให้ท่าน
                  ระบบจะแสดงหน้าต่างแจ้งเตือนการฝากเงินสำเร็จ
                </li>
                <li>
                  <span>หากพบปัญหาในการฝากเงิน กรุณาติดต่อเจ้าหน้าที่</span>
                </li>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 grid margin-top-10">
          <div className="border-radius shadow">
            <div className="card color-font-card">
              <div className="heading margin-left-10 margin-right-10">
                <h4 className="font-bold">
                  <span>วิธีถอนเงิน</span>
                </h4>
                <p className="bottom-line-yellow"></p>
              </div>
              <div className="card-body">
                <li>
                  เลือกปุ่ม <span>ถอนเงิน</span>
                </li>
                <li>ระบุจำนวนเงินที่ท่านต้องการถอน</li>
                <li>การทำรายการถอนเงินขั้นต่ำครั้งละ 10.00 เครดิตขึ้นไป</li>
                <li>
                  ระบบจะทำการตรวจสอบข้อมูลและทำธุรกรรมให้ท่าน
                  เมื่อตรวจสอบข้อมูลเรียบร้อยแล้ว
                </li>
                <li className="font-red font-bold">
                  หากพบปัญหาในการถอนเงิน กรุณาติดต่อเจ้าหน้าที่เพื่อรับทราบปัญหา
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      infomation: infomation,
      isLogin: context.req.cookies.access_token != undefined,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    getinfo: state.member.getinfo,
    isLogin: state.member.isLogin,
  };
};

export default connect(mapStateToProps)(BankPage);
